import React, { FC, ReactElement, ReactNode } from 'react'
import { AVATAR_STUDIO_CATALOGUE } from '../../constants/toggleNames'
import { FeatureToggle } from '../../contexts/toggle-feature'

export interface AvatarStudioFeatureProps {
  children: ReactNode
  /** Shown when the toggle is off. Omit where nothing should render at all. */
  fallback?: ReactElement
}

const AvatarStudioFeature: FC<AvatarStudioFeatureProps> = ({
  children,
  fallback,
}) => (
  <>
    <FeatureToggle.On name={AVATAR_STUDIO_CATALOGUE}>
      {children}
    </FeatureToggle.On>
    {fallback && (
      <FeatureToggle.Off name={AVATAR_STUDIO_CATALOGUE}>
        {fallback}
      </FeatureToggle.Off>
    )}
  </>
)

export default AvatarStudioFeature
